import { IndividualWithFamilySituationType } from "../../types/commonTypes/individualWithFamilySituationType";

export const individualWithFamilySituationInitialState: IndividualWithFamilySituationType = {
    civility: "Monsieur",
    lastName: "",
    firstName: "",
    familySituation: "Célibataire",
    maritalRegime: "Communauté de biens réduite aux acquêts",
    eventDate: "",
    eventPlace: ""   
}